import * as XLSX from 'xlsx';

export const createWorkbook = (columnNames, rows, bookName, widths=[]) => {
    const array = [[]];
    array.push(...rows);

    const worksheet = XLSX.utils.aoa_to_sheet(array);
    XLSX.utils.sheet_add_aoa(worksheet, [columnNames], {origin: "A1"});

    if (widths.length > 0) {
        const mappedWidths = widths.map(pixels => {
            return {width: pixels};
        });
        worksheet["!cols"] = mappedWidths;
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    XLSX.writeFile(workbook, `${bookName}.xlsx`);
};